<template>
  <div
    v-if="blocked && !editing"
    class="vt-video-container"
  >
    <onetrust-blocker />
  </div>
  <div
    v-else
    class="vt-video-container"
  >
    <video-youku
      v-if="video && video.youku"
      :id="id"
      :share="share"
      :data="video.youku"
      :autoplay="autoplay"
      :auto-size="autoSize"
      :poster="poster"
      :sr-label="srLabel"
      :disable-share="disableShare"
    />

    <video-youtube
      v-if="video && video.youtube"
      :id="id"
      :share="share"
      :data="video.youtube"
      :autoplay="autoplay"
      :auto-size="autoSize"
      :poster="poster"
      :sr-label="srLabel"
      :disable-share="disableShare"
    />

    <video-local
      v-if="video && video.local"
      :id="id"
      :share="share"
      :data="video.local"
      :autoplay="autoplay"
      :auto-size="autoSize"
      :poster="poster"
      :sr-label="srLabel"
      :disable-share="disableShare"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import VideoYouku from './vt-video-youku.vue'
import VideoYoutube from './vt-video-youtube.vue'
import VideoLocal from './vt-video-local.vue'

export default {
  name: 'vt-video',
  components: {
    VideoYouku,
    VideoYoutube,
    VideoLocal
  },
  props: {
    videos: {
      type: Object,
      default: null
    },
    poster: {
      type: String,
      default: '/assets/niobiumtech/images/no-image.png'
    },
    share: {
      type: Object,
      default: null
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    srLabel: {
      type: String,
      default: 'Video'
    },
    preferr: {
      type: String,
      default: 'youtube'
    },
    lazy: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    disableShare: {
      type: Boolean,
      default: false
    },
    autoSize: {
      type: Boolean,
      default: true
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      video: null,
      blocked: false
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing',
      'date'
    ])
  },
  watch: {
    date() {
      this.getVideo()
    }
  },
  mounted() {
    if (this.lazy) {
      this.getVideo()
    }
  },
  methods: {
    getVideo() {
      if (!this.marketing) {
        this.blocked = true
      } else {
        this.blocked = false
        this.video = _.pick(this.videos, [this.preferr])
      }
    }
  }
}
</script>
